import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useParcelLeave = () => {
    const send = useGenericSend();

    return useCallback(async ({ mysteryParcelId }: Types.IParcelLeaveRequestData) => {
        const response = await send<Types.IParcelLeaveRequestData>({
            ID: 73060,
            mysteryParcelId,
            responses: [73061, 73062],
            description: 'Mystery Parcel leave request'
        });

        return response;
    }, [send]);
};
